<template>
  <div class="navigation-progress-container">
    <p class="progress-label">
      {{ label }}
    </p>
    <div class="progress-container">
      <div class="progress-bar" :style="percentageFill"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavigationProgressBarWuk',
  props: {
    label: {
      type: String,
      default: '',
    },
    currentPage: {
      type: Number,
      required: true,
    },
    maxPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    percentageFill() {
      return { width: `${((this.currentPage * 100) / this.maxPage)}%` };
    },
    page() {
      if (this.currentPage > this.maxPage) {
        return this.maxPage;
      }
      if (this.currentPage < 0) {
        return 0;
      }

      return this.currentPage;
    },
  },
};
</script>

<style lang="scss" scoped>
  .progress-container {
    $chart-thickness: 4px;
    width: 100%;
    height: $chart-thickness;
    border-radius: 100px;
    overflow: hidden;
    background-color: $secondary-color-light;
    margin-top: 0.3125em;
  }

  .progress-bar {
    height: 100%;
    transition: width 0.6s ease-in-out;
    width: 0;
    background: $stepper-bar-background;
    border-radius: 100px;
  }

  .progress-label {
    font-size: 14px; // TODO  CHANGED THIS to -> @extend %t3;
    text-align: right;
    margin-top: 0;
    margin-bottom: 0;

    @media (max-width: break-wuk('small', 'l')) {
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }
  }
</style>
